export const DATE_CONSTANTS = {
  // Date format patterns
  DISPLAY_FORMAT: 'MM/dd/yy',
  STORAGE_FORMAT: 'yyyy-MM-dd',

  // Calendar display
  YEARS_PER_PAGE: 24,
  DAYS_PER_PAGE: 42,

  // Input formatting
  MONTH_AUTO_PREFIX_THRESHOLD: 2, // Auto-prefix 0 if month > 2
  DAY_AUTO_PREFIX_THRESHOLD: 3,   // Auto-prefix 0 if day > 3
} as const;

export const DAY_NAMES = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'] as const;
